import React, { useState } from 'react';
import './studydocmaterial.css';
import arr from '../../assets/studyMaterial/arr.png';
import '../DOC/docCard.css';
import StudymDoc from './studymDoc';

export default function CardView({ subjectData, globalDocuments, handleMarkAsComplete, ...props }) {
  return (
    <div className="subject-container">
      <div className="container-studym">
        <ParentContainer
          {...subjectData}
          props={props}
          globalDocuments={globalDocuments}
          handleMarkAsComplete={handleMarkAsComplete}
        />
      </div>
    </div>
  );
}

const filesCount = (studyMaterialMap = {}) => {
  return Object.values(studyMaterialMap).reduce((acc, files) => acc + (files?.length || 0), 0);
};

function ParentContainer(props) {
  const [open, setOpen] = useState(false);

  return (
    <div className="second-div">
      <div className="divvvvvva" onClick={() => setOpen(!open)}>
        <div>
          <button className="buttonsub">
            <img src={arr} alt="→" />
          </button>
          <span className="subtopicname">{props?.topicName ?? props.subjectName}</span>
        </div>
        <span className="no-of-files" style={{ fontSize: '10px' }}>
          Topics: {props.subtopicList?.length ?? 0}
          {filesCount(props.studyMaterialMap) > 0 && (
            <p>&nbsp;, &nbsp;Files: {filesCount(props.studyMaterialMap)}</p>
          )}
        </span>
      </div>

      {open && (
        <div>
          <FileContainer
            Study_Material_files={props.studyMaterialMap}
            topic_name={props?.topicName ?? props.subjectName}
            {...props.props}
            globalDocuments={props.globalDocuments}
            handleMarkAsComplete={props.handleMarkAsComplete}
          />
          {props.subtopicList?.map((data, index) => (
            <ParentContainer
              {...data}
              key={index}
              props={props.props}
              globalDocuments={props.globalDocuments}
              handleMarkAsComplete={props.handleMarkAsComplete}
            />
          ))}
        </div>
      )}
    </div>
  );
}

const FileContainer = ({
  Study_Material_files,
  topic_name,
  globalDocuments = [],
  handleMarkAsComplete,
  ...props
}) => {
  const handleClick = (el, type) => {
    const fileName = el?.file_name ?? '';
    const ext = fileName.split('.').pop().toLowerCase();

    const imageTypes = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
    const audioTypes = ['mp3', 'aac', 'wav', 'ogg'];
    const documentTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'pdf', 'txt'];

    if (imageTypes.includes(ext)) props.image(el);
    else if (audioTypes.includes(ext)) props.listen(el);
    else if (documentTypes.includes(ext)) props.view(el);
    else if (type === 'VDOCipher' || (el.videoID && el.is_vdocipher)) props.vdocipherApicalling(el);
    else if (type === 'Vimeo' || (el.videoID && el.is_vimeo)) props.vimeo(el);
    else if (type === 'YoutubeURL' || el.youtubeVideoID) props.youtubeVideo(el);
    else props.view(el);
  };

  return (
    Study_Material_files &&
    Object.keys(Study_Material_files).map((type) =>
      Study_Material_files[type].map((doc) => {
        const globalDoc = globalDocuments.find(
          (d) => d.file_id === doc.file_id && d.topicName === topic_name
        );

        if (!globalDoc) return null;

        const { isLocked, isMarked, globalIndex } = globalDoc;

        return (
          (props.search === '' || doc.title.toUpperCase().includes(props.search.toUpperCase())) && (
            <StudymDoc
              key={`${topic_name}-${doc.file_id}`}
              el={globalDoc}
              index={globalIndex}
              heading_name={doc.title}
              date={doc.student_file_share_date}
              type={type}
              handleClick={handleClick}
              file_name={doc?.file_name ?? ''}
              topic={topic_name}
              category_name={doc.category_name}
              download={!isLocked ? props.download : undefined}
              view={!isLocked ? props.view : undefined}
              downloadvimeo={!isLocked ? props.downloadvimeo : undefined}
              UpdatVimeoWatchCall={!isLocked ? props.UpdatVimeoWatchCall : undefined}
              vdocipherApicalling={!isLocked ? props.vdocipherApicalling : undefined}
              youtubeVideo={!isLocked ? props.youtubeVideo : undefined}
              vimeo={!isLocked ? props.vimeo : undefined}
              image={!isLocked ? props.image : undefined}
              listen={!isLocked ? props.listen : undefined}
              is_readonly={doc.is_readonly}
              vimeo_video_downlodable={props.subjectData?.vimeo_video_downlodable}
              video_url={doc.video_url}
              posterUrl={doc.posterUrl}
              posterList={doc.posterList}
              isLocked={isLocked}
              isMarked={isMarked}
              onMarkComplete={() => handleMarkAsComplete(globalIndex)}
              institute_id={props.institute_id}
              student_id={props.student_id}
              user_id={props.user_id}
              student_auth={props.student_auth}
            />
          )
        );
      })
    )
  );
};
